import type { ComponentProps, FC } from 'react'

import Link from 'next/link'

type PageLinkProps = ComponentProps<typeof Link>

/** Internal link. Pages swap instantly and scroll to the top (or the hash). */
export const PageLink: FC<PageLinkProps> = props => {
    return (
        <Link
            {...props}
        />
    )
}
